import { CallbackProps } from "@/lib/context/widget-provider";
import React, { createContext, FC, PropsWithChildren } from "react";

export const CallbackContext = createContext<CallbackProps>({});

const CallbackProvider: FC<PropsWithChildren<CallbackProps>> = ({
  children,
  onGetAddresses,
  onGetBalance,
  onWidgetOpenChange,
  widgetOpen,
  isLoading,
  hasAccount,
}) => {
  return (
    <CallbackContext.Provider
      value={{
        onGetAddresses,
        onGetBalance,
        onWidgetOpenChange,
        widgetOpen,
        isLoading,
        hasAccount,
      }}
    >
      {children}
    </CallbackContext.Provider>
  );
};

export default CallbackProvider;
